import {ActionBarBehavior} from "../action-bar-behavior";
import { CustomActionEvent } from '../../service/custom-action-event';
import { HttpCustomService } from 'src/service/http-custom.service';
import { NotificationService } from 'src/shared/service/notification.service';
import { ActionBarService } from 'src/shared/service/action-bar.service';
import { ActionBarConfig } from 'src/shared/model/action-bar-config';
import { ActionBarType } from 'src/shared/constants/action-bar-type.enum';
import { CustomActionBarTypeEnum } from 'src/shared/constants/custom-action-bar-type.enum';
import { ActionBarAction } from 'src/shared/constants/action-bar.action';
import { HttpMethod } from 'src/shared/constants/http-method.enum';
import { ActionState } from 'src/shared/constants/action-state.enum';
import { UrlType } from 'src/shared/constants/url-type.enum';
import * as _ from 'lodash';
import { Injectable } from '@angular/core';

@Injectable()
export class SaveActionBarBehavior extends ActionBarBehavior {

  constructor(
    private csCustomAction: CustomActionEvent,
    private httpService: HttpCustomService,
    private notificationService: NotificationService,
    private csEventService: ActionBarService
  ) {
    super();
  }

  executeAction(actionBarConfig: ActionBarConfig, selectedRecords: any[], additionalParams: any) {
    const actionConfig = _.find(actionBarConfig.buttonBarConfigs, conf => conf.actionBarType === ActionBarType.SAVE);
    if (actionConfig && actionConfig.customAction) {
      this.csEventService.emitChange(ActionBarAction.ON_SAVE);
      this.csCustomAction.emitChange({type: CustomActionBarTypeEnum.SAVE, value: true, actionId: additionalParams.actionId});
    } else {
      const body = Object.values(selectedRecords)[0];
      const actualMethod = actionConfig && actionConfig.method ? actionConfig.method : HttpMethod.PUT;
      const httpRequest = this.httpService.request(actualMethod, actionBarConfig.urlType[UrlType.SAVE], body);
      httpRequest.subscribe((res: any) => {
        if (res) {
          this.csCustomAction.emitChange({type: CustomActionBarTypeEnum.SAVE, value: res, actionId: additionalParams.actionId});
          this.csEventService.emitChange(ActionBarAction.SAVE_DONE);
          this.notificationService.showPerformSuccessOneRecord(ActionState.UPDATE);
        }
      });
    }
  }

  isActionBar(type: ActionBarType): boolean {
    return ActionBarType.SAVE === type;
  }
}
